import _ from 'lodash';

import { formatGuidelineCitationText } from 'constants/aiChat';

export const buildAskAboutGuidelinePrompt = citation =>
  `Tell me more about ${formatGuidelineCitationText(citation)} — ${
    citation.title
  } and how it applies to this loan.`;

export const formatGuidelineExpanderCardContentCopyText = contentProps => {
  const source = contentProps.sourceShortName ?? contentProps.sourceName ?? '';
  const section = contentProps.sectionNumber ?? '';
  const title = contentProps.sectionTitle ?? '';
  const excerpt = contentProps.excerpt ?? '';
  const header = _.compact([source, section, title]).join(' ');

  return excerpt ? `${header}\n${excerpt}` : header;
};
